import { extensionEditorStyles } from '@bingads-webui-campaign-react/common-styles';

export const getGlobalLogoPickerStyles = (_, { palette = {} }) => ({
  '@global': {
    ...extensionEditorStyles({ palette }),
  },
});
